import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { checkIfPermitted } from "../services/RolePermissionService";
import Permissions from "../utils/PermissionKeys.json"


const PermissionRoute = ({component: Component, keyObj, ...rest}) => {
   
   let authed = checkIfPermitted(keyObj);
   let loggedIn = !!(JSON.parse(localStorage.getItem("USER_INFO")) && 
   JSON.parse(localStorage.getItem("USER_INFO")).token);
   //console.log("loggedIn", loggedIn)
    return (
      <Route
        {...rest}
        render={(props) => authed === true && loggedIn === true
          ? <Component {...props} />
          : <Redirect to={{pathname: '/app/access-denied', state: {from: props.location}}} />}
      />
    )
  }

  export default PermissionRoute;